import React from 'react';
import { FieldErrorMessageProps } from '@common/types/hilbi-form';
import { FieldErrorMessageSC } from './field-error-message.styled';

const FieldErrorMessage: React.FC<FieldErrorMessageProps> = ({ message }) => {
  return (
    <FieldErrorMessageSC className={'field-error'}>
      {message ? <span className={'error'}>{message}</span> : null}
    </FieldErrorMessageSC>
  );
};

export default FieldErrorMessage;
